const _require = require(/* configBehaviorIgnore: true */'../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate previousReportsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const _await$sourceEvaluato = await sourceEvaluator({
      type: 'jobReferenceBehavior'
    }),
    jobID = _await$sourceEvaluato.id;
  const reportID = content.id,
    reportTypeIdentifier = content.reportType.identifier;
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'Report',
    properties: ['reportType/name', 'reportNumber'],
    equals: {
      'job/id': jobID,
      'reportType/identifier': reportTypeIdentifier
    },
    doesNotEqual: {
      id: reportID
    },
    ifContent: {
      atPath: parentContentPath
    },
    orderBy: [{
      property: 'reportType/name',
      ascending: false
    }, {
      property: 'reportNumber',
      ascending: false
    }]
  };
  const reports = await sourceEvaluator(querySource);
  const result = {};
  for (let i = 0; i < reports.length; i += 1) {
    const report = reports[i];
    const fullName = "".concat(report.reportType.name, " ").concat(report.reportNumber);
    result[report.id] = {
      title: fullName,
      _created: i
    };
  }
  return result;
};
module.exports = {
  evaluate
};